import React, { useState, useEffect } from "react";
import "./custom.css"; // Custom CSS for styling
import DocumentationViewer from "../components/DocumentationViewer";
import { useNavigate, useParams } from "react-router-dom";
import { markdownPaths } from "../types/markdownPaths";
// Define the available sections as a union type for better typing
type Section =
  | "overview"
  | "materials"
  | "energy"
  | "production"
  | "logistics"
  | "electronics";

const DatbaseOverviewPage: React.FC = () => {
  const navigate = useNavigate();
  const { section } = useParams<{ section: Section }>();
  const [selectedSection, setSelectedSection] = useState<Section>("overview");

  // Update the selected section based on the URL parameter
  useEffect(() => {
    if (section) {
      setSelectedSection(section);
    }
  }, [section]);

  // Function to switch sections and update the URL
  const handleSectionChange = (section: Section) => {
    setSelectedSection(section);
    navigate(`/knowledge-hub/database-overview/${section}`);
  };

  return (
    <div className="api-concepts-page">
      {/* Horizontal Menu with Section Categories */}
      <nav className="api-concepts-menu bg-gray-100 p-4">
        <ul className="flex justify-center space-x-8">
          <li
            className={`cursor-pointer ${
              selectedSection === "overview" ? "text-green-600 font-bold" : ""
            }`}
            onClick={() => handleSectionChange("overview")}
          >
            Overview
          </li>
          <li
            className={`cursor-pointer ${
              selectedSection === "materials" ? "text-green-600 font-bold" : ""
            }`}
            onClick={() => handleSectionChange("materials")}
          >
            Materials
          </li>
          <li
            className={`cursor-pointer ${
              selectedSection === "energy" ? "text-green-600 font-bold" : ""
            }`}
            onClick={() => handleSectionChange("energy")}
          >
            Energy
          </li>
          <li
            className={`cursor-pointer ${
              selectedSection === "production" ? "text-green-600 font-bold" : ""
            }`}
            onClick={() => handleSectionChange("production")}
          >
            Production
          </li>
          <li
            className={`cursor-pointer ${
              selectedSection === "logistics" ? "text-green-600 font-bold" : ""
            }`}
            onClick={() => handleSectionChange("logistics")}
          >
            Logistics
          </li>
          <li
            className={`cursor-pointer ${
              selectedSection === "electronics"
                ? "text-green-600 font-bold"
                : ""
            }`}
            onClick={() => handleSectionChange("electronics")}
          >
            Electronics
          </li>
        </ul>
      </nav>

      {/* Content Area */}
      <div className="content-area">
        {selectedSection === "overview" && (
          <DocumentationViewer filePath={markdownPaths.KHDBOverviewURL} />
        )}

        {selectedSection === "materials" && (
          <DocumentationViewer filePath={markdownPaths.KHMaterialsURL} />
        )}
        {selectedSection === "energy" && (
          <DocumentationViewer filePath={markdownPaths.KHEnergyURL} />
        )}

        {selectedSection === "production" && (
          <DocumentationViewer filePath={markdownPaths.KHProductionURL} />
        )}
        {selectedSection === "logistics" && (
          <DocumentationViewer filePath={markdownPaths.KHLogisticsURL} />
        )}

        {selectedSection === "electronics" && (
          <DocumentationViewer filePath={markdownPaths.KHElectronicsURL} />
        )}
      </div>
    </div>
  );
};

export default DatbaseOverviewPage;
